export class Builds {
	notes: Record<number, Array<string>> = {
		192 : ['February 4, 2026', 'GOLDEN MASTER'],
		191 : ['January 31, 2026', 'final candidate 3'],
		190 : ['January 29, 2026', 'final candidate 2'],
		189 : ['January 26, 2026', 'persist recents in local storage'],
		188 : ['January 25, 2026', 'major housekeeping, minor UI improvements'],
		187 : ['January 21, 2026', 'new recents as source of truth'],
		186 : ['January 14, 2026', 'new public deliverables status page'],
		185 : ['January 5, 2026', 'friendlier layout of controls'],
		184 : ['January 1, 2026', 'incorporate new internal documentation database'],
		183 : ['December 27, 2025', 'fully wire up dynamic/static focus'],
		182 : ['December 24, 2025', 'preference option to show children counts as numbers'],
		181 : ['December 22, 2025', 'restore grabs when navigating history'],
		180 : ['December 20, 2025', 'new breadcrumbs history type'],
		179 : ['December 18, 2025', 'new Styles manager centralizes color computation'],
		178 : ['December 17, 2025', 'fully isolate mouse logic within hits manager'],
		177 : ['December 13, 2025', 'mouse responder is dead!'],
		176 : ['December 2, 2025', 'new curved cluster titles'],
		175 : ['December 1, 2025', 'new hover system'],
		174 : ['November 25, 2025', 'click drag dot changes focus (in both graph modes)'],
		173 : ['November 18, 2025', 'decrease spacing everywhere'],
		172 : ['November 14, 2025', 'simplified non-standalone UI mode'],
		171 : ['November 3, 2025', 'tag and trait details now correctly use s items'],
		170 : ['October 25, 2025', 'refactored hover logic'],
		169 : ['October 19, 2025', 'revised bubble plugin API'],
		168 : ['October 8, 2025', 'adopt s items design for recents, search and tags'],
		167 : ['September 21, 2025', 'move search controls to left of breadcrumbs'],
		166 : ['September 17, 2025', 'new secondary controls: more room for search and tree type'],
		165 : ['September 11, 2025', 'revise plugin names, add data load spinner, repair search'],
		164 : ['September 7, 2025', 'super fast search'],
		163 : ['September 3, 2025', 'suppress select and focus events during plugin data download'],
		162 : ['August 26, 2025', 'fix bugs (editing, layout, color, hover), new print utility'],
		161 : ['August 9, 2025', 'rubberband and command drag'],
		160 : ['August 8, 2025', 'wire up focus and select for bubble plugin'],
		159 : ['August 7, 2025', 'new zoom buttons. tolerate space in parents and related field names'],
		158 : ['July 31, 2025', 'adopt Vincent\'s proposal for parents and related'],
		157 : ['July 27, 2025', 'add focus and grabs to plugin fields'],
		156 : ['July 25, 2025', 'using data received from bubble'],
		155 : ['July 24, 2025', 'bubble plugin now receiving valid data'],	
		154 : ['July 18, 2025', 'move tree preferences into tree graph'],
		153 : ['July 12, 2025', 'UI suggestions from Vincent Arena'],
		152 : ['July 5, 2025', 'now loads as a bubble plugin'],
		151 : ['July 1, 2025', 'autorepeat previous and next buttons'],
		150 : ['June 29, 2025', 'support for multiple selected things'],
		149 : ['June 25, 2025', 'hover logic applied everywhere'],
		148 : ['June 20, 2025', 'wired up new recents buttons'],
		147 : ['June 14, 2025', 'show help for actions'],
		146 : ['June 12, 2025', 'use filled to indicate grabbed'],
		145 : ['June 7, 2025', 'new depth limit in display details'],
		144 : ['June 5, 2025', 'new panel layout'],
		143 : ['June 2, 2025', 'details banners now have glowing buttons'],
		142 : ['May 25, 2025', 'should now read tags table from firebase'],
		141 : ['May 25, 2025', 'brand new details view'],
		140 : ['May 24, 2025', 'begin work on tags'],
		139 : ['May 22, 2025', 'hopefully stable import from marianne as csv into firebase'],
		138 : ['May 20, 2025', 'reorganize details so title is always visible'],
		137 : ['May 19, 2025', 'new traits details'],
		136 : ['May 14, 2025', 'read marianne\'s csv file into local db'],
		135 : ['May 12, 2025', 'all go wired and working'],
		134 : ['May 3, 2025', 'new go in Details'],
		133 : ['April 3, 2025', 'new control to show related relationships'],
		132 : ['March 19, 2025', 'new radial UX'],
		131 : ['March 18, 2025', 'fast and smooth response to editing and rotating'],
		130 : ['March 10, 2025', 'title editor busts ass, new Ancestry-centric architecture'],
		129 : ['February 13, 2025', 'title editor temporarily broken'],
		128 : ['January 29, 2025', 'display details, finish logic for controlling tiny dots'],
		127 : ['January 21, 2025', 'fixed translation of thing ids during import'],
		126 : ['December 29, 2024', 'rename rings as radial'],
		125 : ['December 28, 2024', 'working import and export buttons in Storage'],
		124 : ['December 27, 2024', 'files can move across dbs'],
		123 : ['December 19, 2024', 'begin work on tutorial'],
		122 : ['December 17, 2024', 'improved details'],
		121 : ['December 11, 2024', 'fix breadcrumb button cosmetics'],
		120 : ['December 9, 2024', 'save and read subtrees'],
		119 : ['November 30, 2024', 'can save to a file (and fetch) entire hierarchy'],
		118 : ['November 27, 2024', 'OFFICIAL ALPHA RELEASE'],
		117 : ['November 19, 2024', 'new details mode segmented'],
		116 : ['November 1, 2024', 'adopt segmented controls'],
		115 : ['October 6, 2024', 'graph, touch, controls on mobile'],
		114 : ['October 2, 2024', 'begin work on mobile)'],
		113 : ['September 24, 2024', 'add new game feature (consequences & quests)'],
		112 : ['September 12, 2024', 'new info details'],
		111 : ['September 8, 2024', 'new resize ring'],
		110 : ['August 30, 2024', 'airtable dbid support'],
		109 : ['August 22, 2024', 'rotate cluster label tangent to arc'],
		108 : ['August 18, 2024', 'paging persists for multiple things and dbs'],
		107 : ['August 12, 2024', 'thumb works (funky)'],
		106 : ['August 1, 2024', 'fixed netlify cluster mode'],
		105 : ['July 30, 2024', 'corrected thumb position and shape of arc and thumb'],
		104 : ['July 2, 2024', 'save and restore paging thumb position'],
		103 : ['June 30, 2024', 'paging thumb button works'],
		102 : ['June 18, 2024', 'visibility logic for advance buttons'],
		101 : ['June 13, 2024', 'limit the number of things within each cluster'],
		100 : ['June 6, 2024', 'significantly reduce stutter during rotation_ring rotation'],
		99 : ['June 4, 2024', 'expand help content and move to help-webseriously.netlify.app'],
		98 : ['May 23, 2024', 'double-click drag to alter ring button radius'],
		97 : ['May 20, 2024', 'cluster rotation perfected, improved memory usage'],
		96 : ['May 14, 2024', 'nearly perfect cluster curly braces, new cluster line angles'],
		95 : ['May 10, 2024', 'add color editing'],
		94 : ['May 4, 2024', 'replace to/from with child/parent and directions with isBidirectional'],
		93 : ['May 2, 2024', 'convert cluster arc into a bracket ( { )'],
		92 : ['April 29, 2024', 'assure things fit in cluster, show cluster arc'],
		91 : ['April 23, 2024', 'fix hover, grab highlight, go, switching db'],
		90 : ['April 10, 2024', 'display related things clusters'],
		89 : ['March 28, 2024', 'display focus in clusters'],
		88 : ['March 26, 2024', 'resume support for Airtable'],
		87 : ['March 22, 2024', 'begin work on circle layout'],
		86 : ['March 10, 2024', 'vertical parent count dots inside drag dot'],
		85 : ['March 6, 2024', 'move tiny dots in crumbs to surround reveal dots'],
		84 : ['March 3, 2024', 'click title of thing to grab, tiny dots in crumbs'],
		83 : ['February 24, 2024', 'cluster go: hover and disable logic'],
		82 : ['February 16, 2024', 'add zoom in/out buttons for mobile'],
		81 : ['February 15, 2024', 'new panel layout'],
		80 : ['February 13, 2024', 'dynamic ancestries for child and parent all seemingly working'],
		79 : ['February 2, 2024', 'working on relations'],
		78 : ['January 29, 2024', 'added two new go to go cluster'],
		77 : ['January 27, 2024', 'go cluster is now an overlay hiding title and reveal dot'],
		76 : ['January 25, 2024', 'relocate focus title in graph (default with url query alternative)'],
		75 : ['January 23, 2024', 'switched ancestry ids from things to relationships'],
		74 : ['January 20, 2024', 'fixed most remaining ancestry design bugs'],
		73 : ['January 13, 2024', 'ancestries mostly working'],
		72 : ['January 11, 2024', 'ancestry based design'],
		71 : ['January 7, 2024', 'try to stop using thing ids for grab, focus, etc.'],
		70 : ['December 24, 2023', 'center graph'],
		69 : ['December 21, 2023', 'remount graph on relocate and hide/show children'],
		68 : ['December 17, 2023', 'relayout on title edit keystrokes'],
		67 : ['December 15, 2023', 'add div and origin to all components, position: absolute'],
		66 : ['November 28, 2023', 'configuration netlify content security profile'],
		65 : ['November 27, 2023', 'size slider'],
		64 : ['November 24, 2023', 'perfect scrolling'],
		63 : ['November 20, 2023', 'add select notification'],
		62 : ['November 13, 2023', 'cluster dot tweaks'],
		61 : ['November 13, 2023', 'lots of cosmetic cleanups & added query string'],
		60 : ['November 12, 2023', 'massive cosmetic tweaks'],
		59 : ['November 9, 2023', 'added ip logging'],
		58 : ['November 3, 2023', 'begin work on reveal cluster'],
		57 : ['October 31, 2023', 'separate bulk collections'],
		56 : ['October 27, 2023', 'fat triangle for all reveal dots'],
		55 : ['October 25, 2023', 'double-click drag dot applies focus'],
		54 : ['October 21, 2023', 'restore details at left'],
		53 : ['October 20, 2023', 'fix add child bugs'],
		52 : ['October 13, 2023', 'new bulks correctly created'],
		51 : ['October 12, 2023', 'new admin view of all data'],
		50 : ['October 10, 2023', 'eliminate details view, show focus title at top'],
		49 : ['October 10, 2023', 'create private firebase bulks as needed'],
		48 : ['October 9, 2023', 'private firebase bulks'],
		47 : ['October 9, 2023', 'two netlify query string'],
		46 : ['October 8, 2023', 'perfect editing and browsing'],
		45 : ['October 7, 2023', 'children origins are perfect'],
		44 : ['October 5, 2023', 'scrolling works'],
		43 : ['October 3, 2023', 'fetch Catalist data, HAH!'],
		41 : ['October 3, 2023', 'almost perfectly laid out graph'],
		40 : ['September 26, 2023', 'lines use children height'],
		39 : ['September 19, 2023', 'highlight grabbed root, eliminate line clipping'],
		38 : ['September 18, 2023', 'add fat triangle for focus, click it to go left'],
		37 : ['September 16, 2023', 'position widgets correctly at ends of curves'],
		36 : ['September 12, 2023', 'draw curves, switch public to show them'],
		35 : ['September 8, 2023', 'begin work on bubble plugin and svg'],
		34 : ['September 3, 2023', 'crumbs update on db switch'],
		33 : ['September 2, 2023', 'separate hierarchy for each db'],
		32 : ['August 31, 2023', 'manage order changes in snapshots'],
		31 : ['August 30, 2023', 'add child, duplicate and delete'],
		30 : ['August 26, 2023', 'clean construction of relationships'],
		29 : ['August 22, 2023', 'synchronize relocated things'],
		28 : ['August 21, 2023', 'synchronize title edits'],
		27 : ['August 20, 2023', 'firebase relationships'],
		26 : ['August 17, 2023', 'cloud abstraction layer'],
		25 : ['August 15, 2023', 'switch between db T_Signal'],
		24 : ['August 15, 2023', 'bulk for private/public, shared predicates'],
		23 : ['August 14, 2023', 'synchronization works, a goal 8 years long'],
		22 : ['August 13, 2023', 'locally persist db type'],
		21 : ['August 13, 2023', 'select db type'],
		20 : ['August 13, 2023', 'firebase private databases'],
		17 : ['August 12, 2023', 'better help'],
		12 : ['August 10, 2023', 'relocate things'],
		11 : ['August 8, 2023', 'display build number'],
		10 : ['August 2, 2023', 'refactor Panel into Startup'],
	}
	build_number: string = Object.keys(this.notes).slice(-1)[0];		// needed for builds button. grab the keys, then grab the last of them

}

export const builds = new Builds();
